import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = '$';

const slice = createSlice({
  name: 'currencySymbol',
  initialState,
  reducers: {
    setCurrencySymbol(state, action: PayloadAction<string>) {
      return action.payload;
    },
  },
});

export const { setCurrencySymbol } = slice.actions;

export default slice.reducer;
